import { render } from "./action-modal.vue?vue&type=template&id=2c1254f8&ts=true"
import script from "./action-modal.vue?vue&type=script&lang=ts"
export * from "./action-modal.vue?vue&type=script&lang=ts"

import "./action-modal.vue?vue&type=style&index=0&id=2c1254f8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__